/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation VendorUpdateMutation(
  $vendorId: ID!,
  $displayName: String!,
  $email: EmailAddress!,
  $address: String!,
  $phone: String!,
  $billingPeriod: BILLING_PERIOD!,
  $billingEmail: [EmailAddress!]!,
  $technicalEmail: EmailAddress!,
  $billingAddress: String,
  $billingCurrency: String,
  $country: String
) {
  VendorUpdate(
    vendorId: $vendorId,
    displayName: $displayName,
    email: $email,
    address: $address,
    billingPeriod: $billingPeriod,
    billingEmail: $billingEmail,
    billingCurrency: $billingCurrency,
    billingAddress: $billingAddress,
    technicalEmail: $technicalEmail,
    phone: $phone,
    country: $country
  ) {
    message
    status
  }
}
`
